(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeContactInfoController', Controller);

    Controller.$inject = ['$scope', '$q', '$state', 'employeeProfileService', 'loookupService', 'authenticatedUser', 'employeeWithLocations'];

    function Controller($scope, $q, $state, employeeProfileService, loookupService, authenticatedUser, employeeWithLocations) {

        $scope.updateTopBar('Contact Info', 'fa fa-building-o');

        $scope.officeLocation = /^[^|]*$/;
        $scope.phoneStrippedRegex = /^[0-9()\ .\-]{1,15}$/;
        $scope.phoneExtensionRegex =  /^[0-9]{1,10}$/;

        $scope.authenticatedUser = authenticatedUser;
        $scope.isRestrictedZone = (employeeWithLocations.IsRestrictedZone === true);
        $scope.employeeWithLocations = employeeWithLocations;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.needSavesChanges = false;

        // Get Countries and Employee Xref Locations
        $scope.countriesByCallingCode = {};
        $q.all({
            countries: loookupService.getCountries(),
            empXrefLocations: employeeProfileService.getEmployeeXrefLocations()
        }).then(function (responses) {
            var countries = _.map(responses.countries, function (country) {
                var ccCode = '+' + country.callingCode[0];
                var mappedCountry = country.name;
                mappedCountry.xrefCountryCode = country.ccn3; // ISO 3166-1 numeric => CountryCode in Xref Location
                mappedCountry.callingCode = ccCode;
                mappedCountry.displayName = country.name.common + ' (' + ccCode + ')';
                mappedCountry.selectedDisplayName = ccCode + '  ' + country.name.common;

                return mappedCountry;
            });

            var splittedCountriesWithXrefLocation = _.partition(countries, function (cty) {
                return _.some(responses.empXrefLocations, { CountryCode: cty.xrefCountryCode });
            });

            var countriesLinkedByXrefLocation    = splittedCountriesWithXrefLocation[0];
            var countriesNotLinkedByXrefLocation = _.sortBy(splittedCountriesWithXrefLocation[1], 'common');
            if (countriesNotLinkedByXrefLocation.length > 0) countriesNotLinkedByXrefLocation[0].isFirstNotLinkXrefCountry = true;

            $scope.countries = _.union(countriesLinkedByXrefLocation, countriesNotLinkedByXrefLocation);

            // Xref Locations
            $scope.employeeXrefLocations =
                _.chain(responses.empXrefLocations)
                 .map(function (xrefLocation) {
                     xrefLocation.displayName = xrefLocation.EmployeeLocation + ' - ' + xrefLocation.CountryName;

                     return xrefLocation;
                 })
                 .sortBy('displayName')
                 .value();

            // Available To Add
            $scope.availableXrefLocationsToAdd = _.reject($scope.employeeXrefLocations, function (xrefLoc) {
                return _.some($scope.employeeWithLocations.EmployeeSecondaryLocations, { EmployeeXRefLocationID: xrefLoc.EmployeeXRefLocationID });
            });
        });

        // Page Is Dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSavesChanges = true;
        };

        // Page Is Not Dirty
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSavesChanges = false;
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Save Employee With Locations
        $scope.saveEmployeeWithLocations = function () {

            // Primary location: Rebuild Phone From Parts
            $scope.employeeWithLocations.IamPhone = rebuildPhoneFromParts($scope.employeeWithLocations.IamPhoneParts);
            $scope.employeeWithLocations.IamMobilePhone = rebuildPhoneFromParts($scope.employeeWithLocations.IamMobilePhoneParts);

            // Secondary Locations: Rebuild Phone From Parts
            $scope.employeeWithLocations.EmployeeSecondaryLocations =
                _.map($scope.employeeWithLocations.EmployeeSecondaryLocations, function (secLocation) {
                    secLocation.Phone = rebuildPhoneFromParts(secLocation.PhoneParts);
                    secLocation.MobilePhone = rebuildPhoneFromParts(secLocation.MobilePhoneParts);

                    return secLocation;
                });

            employeeProfileService
                .updateEmployeeLocations($scope.employeeWithLocations)
                .then(function () {
                    $state.reload();
                });
        };

        // Add Secondary Lecation
        $scope.addSecondaryLocation = function (xrefLoc) {
            $scope.employeeWithLocations.EmployeeSecondaryLocations.push({
                EmployeeID: $scope.employeeWithLocations.EmployeeID,
                EmployeeXRefLocationID: xrefLoc.EmployeeXRefLocationID,
                IsPublicMobilePhone: true
            });

            $scope.availableXrefLocationsToAdd = _.reject($scope.availableXrefLocationsToAdd, { EmployeeXRefLocationID: xrefLoc.EmployeeXRefLocationID });
            $scope.pageIsDirty();
        };

        // Helpers
        function rebuildPhoneFromParts(phoneParts) {
            if (!phoneParts) return null;

            var phoneExtension = '';
            if (phoneParts.PhoneExtension) phoneExtension = ' x' + phoneParts.PhoneExtension;

            var phoneCallingCode = ''
            if (phoneParts.PhoneCallingCode) phoneCallingCode = phoneParts.PhoneCallingCode;

            if (!phoneParts.PhoneExtension && !phoneParts.PhoneCallingCode) return null;

            return phoneCallingCode + ' ' +
                    phoneParts.PhoneStripped +
                    phoneExtension;
        }
     
    }
})();